/**
 * Props for a toggle switch.
 *
 * @since 1.0.0
 */
export interface ToggleSwitchProps {
    isChecked: boolean;
    label: string;
    onToggle: (next: boolean) => void;
    isDisabled?: boolean;
    isPlanned?: boolean;
}

/**
 * The small sliding switch used in the forms and checks tables. It is a real button with
 * switch semantics, so it works from the keyboard and announces its state.
 *
 * @since 1.0.0
 * @param props - the state, accessible label, change handler and whether it is disabled or merely planned
 * @returns the switch element
 */
export function ToggleSwitch({ isChecked, label, onToggle, isDisabled = false, isPlanned = false }: ToggleSwitchProps) {
    /**
     * Flips the switch.
     *
     * @since 1.0.0
     * @returns void
     */
    function handleClick(): void {
        onToggle(!isChecked);
    }

    return (
        <button
            aria-checked={isChecked}
            aria-label={label}
            className="fkwd-switch"
            data-planned={isPlanned ? '' : undefined}
            disabled={isDisabled}
            onClick={handleClick}
            role="switch"
            type="button"
        />
    );
}
